<template>
  <div>
    <template v-for="(menu, index) in menuData">
      <el-submenu
        :key="menu.categoryId"
        :index="menu.categoryId.toString()"
        v-if="menu.children != ''"
        @click="clickMenu(menu)"
      >
        <template slot="title">
          <i
            v-if="index2 == index"
            v-for="(icon, index2) in icons"
            :key="index2"
            :class="icon"
            style="font-size: 22px; margin-right: 10px"
          />
          <span
            style="width: 100%; display: inline-block"
            slot="title"
            @click="clickMenu(menu)"
          >
            {{ menu.categoryName }}
          </span>
        </template>
        <menu-tree :menuData="menu.children"></menu-tree>
      </el-submenu>
      <el-menu-item
        :key="menu.categoryId"
        :index="menu.categoryId.toString()"
        v-else
        @click="clickMenu(menu)"
      >
        <i :class="menu.icon"></i>
        <span slot="title" style="padding-left: 15px">
          {{ menu.categoryName }}
        </span>
      </el-menu-item>
    </template>
  </div>
</template>
 
<script>
import api from "@/api";
import { listSearchMixin } from "@/config/mixin";
export default {
  mixins: [listSearchMixin],
  props: ["menuData"],
  name: "MenuTree",
  data() {
    return {
      bread: [],
      icons: [
        "icon-Shopping-guide",
        "icon-Order-problem",
        "icon-Payment-issues",
        "icon-The-invoice-issue",
        "icon-After-sales-service",
        "icon-Accounts-and-Members",
      ],
    };
  },
  created() {},
  directives: {
    click: {
      inserted(el, binding, index) {
        if (binding.value === 0) {
          el.click();
        }
      },
    },
  },
  methods: {
    clickMenu(item) {
      this.bread.push(item);
      this.$store.commit("selectMenu", item);
      //  localStorage.setItem('bread',this.bread)
      //  let a = localStorage.getItem('bread')
      this.flag = true;
      //调用vuex的selectMenu方法存储数据
      this.$store.commit("selectMenu", item);
      // this.$router.push({
      //   path:'/mainView?categoryId=' + item.categoryId,
      // })
      let self = this;
      let params = {
        url: api.getArticle + "/" + item.categoryId,
        method: "POST",
      };
      self.sendReq(params, (res) => {
        if (res.code == 200) {
          if (res.data.length != 0 && res.data[0].articleList) {
            this.$store.dispatch("selectAticle", res.data[0].articleList);
          } else {
            this.$store.dispatch("selectAticle", [
              { detail: "该分类下暂无文章" },
            ]);
          }
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/helpCenter/menuTree.vue